/* fc-essentials.js (2026-10-12 speed pass): the accessories rail arrows and their disabled states.
   Moved out of sections/fc-essentials.liquid so browsers cache it across pages; the
   root is #fce and per-instance values travel as data attributes. The
   body is the former inline script, unchanged apart from those lookups.
   Re-initialises on shopify:section:load for the theme editor. */
(function () {
  'use strict';
  function initSection(root) {

  var track = root.querySelector('.fce-track');
  var prev = root.querySelector('[data-fce-nav="prev"]');
  var next = root.querySelector('[data-fce-nav="next"]');
  if (!track || !prev || !next) return;

  function step() {
    var tile = track.querySelector('.fce-tile');
    return tile ? tile.offsetWidth + 12 : 260;
  }
  function update() {
    var max = track.scrollWidth - track.clientWidth - 2;
    /* Resting position is ~16px (edge-bleed padding), not 0 */
    prev.disabled = track.scrollLeft <= 20;
    next.disabled = track.scrollLeft >= max;
  }
  prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  var raf;
  track.addEventListener('scroll', function () {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(update);
  }, { passive: true });
  window.addEventListener('resize', update);
  update();

  }
  function init() {
    var root = document.getElementById('fce');
    if (!root || root.getAttribute('data-fc-init') === '1') return;
    root.setAttribute('data-fc-init', '1');
    initSection(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#fce')) init();
  });
})();
